import React from "react";
import TermsContainer from "./TermsContainer";
import Link from "next/link";

import { useScrollTo } from "../services/hooks/useScrollTo";

export default function TermsAndConditions() {
  const { scrollTo } = useScrollTo();

  const handleScroll = (selector) => {
    return (e) => {
      e.preventDefault();

      scrollTo(selector);
    };
  };

  return (
    <TermsContainer>
      <h2>Terms and Conditions</h2>

      <div className="mt-5">
        <p>Effective Date: March 5, 2022.</p>
      </div>

      <div>
        <p>
          Welcome to Chic Beauty Box! Chic Beauty Inc. (“Chic Beauty”, “us” or
          “we”) is the operator of the www.chicbeautybox.com site (the “Site”).
          These terms and conditions, together with any documents they expressly
          incorporate by reference (collectively the “Terms”), govern your
          access and use of the Site, including any content, functionality,
          subscriptions, and services offered on or through the Site, whether as
          a guest or a registered user. These Terms also apply to the purchase
          and sale of products and subscriptions service through the Site.
        </p>
        <p>
          <strong>
            THESE TERMS CONTAIN AN ARBITRATION AGREEMENT AND CLASS ACTION
            WAIVER. PLEASE READ THEM CAREFULLY BEFORE YOU START TO USE THE SITE,
            SINCE THEY AFFECT YOUR LEGAL RIGHTS.
          </strong>
        </p>
        <p>
          <strong>
            By accessing, browsing or using this Site you acknowledge that you
            have read, understood and agreed to be bound and abide by the Terms.
          </strong>{" "}
          If you do not agree to these Terms, you should not use or access this
          Site.{" "}
        </p>
        <p>
          Agreement to these Terms also constitutes your agreement to the{" "}
          <u>
            <Link href="/terms/loyalty">
              <a>Loyalty Program Terms and Conditions</a>
            </Link>
          </u>{" "}
          (the “Loyalty Program Terms”), the Additional Terms (as defined in
          Section 3 of these Terms), and the Chic Beauty Box{" "}
          <u>
            <Link href="/privacy">
              <a>Privacy Policy</a>
            </Link>
          </u>{" "}
          (the “Privacy Policy”), which are incorporated herein
        </p>
        <h4>Table of Contents</h4>
        <p>
          <strong>
            <a href="#" onClick={handleScroll("#toc1")}>
              1. Use of the Site
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc2")}>
              2. Registration and Passwords
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc3")}>
              3. Additional Terms and Conditions
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc4")}>
              4. Site Not for Minors
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc5")}>
              5. Fraud Protection
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc6")}>
              6. Transactions
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc7")}>
              7. The Subscription Contract Between You And Us
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc8")}>
              8. Product Information; Limitation on Quantities
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc9")}>
              9. Proprietary Rights
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc10")}>
              10. Contributed Content Guidelines
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc11")}>
              11. General Disclaimers
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc12")}>
              12. Disclaimer – No Professional Advice
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc13")}>
              13. Taxes
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc14")}>
              14. Indemnification
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc15")}>
              15. Limitation of Liability
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc16")}>
              16. International Use
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc17")}>
              17. Risk of Loss
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc18")}>
              18. Copyright Infringement; Notice and Take Down Procedures
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc19")}>
              19. Waiver; Remedies
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc20")}>
              20. Governing Law
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc21")}>
              21. Disputes
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc22")}>
              22. Changes of the Site
            </a>
          </strong>
          <br />
          <strong>
            <a href="#" onClick={handleScroll("#toc23")}>
              23. Your feedback
            </a>
          </strong>
        </p>

        <h4 id="toc1">1. Use of the Site</h4>
        <p>
          You may use the Site only for your own noncommercial personal use and
          in compliance with these Terms. By using the Website, you represent
          and warrant that you agree to be bound by Canadian laws.
        </p>
        <p>
          We grant you a personal, limited, non-transferable, non-exclusive
          license to access and use the Site. We reserve the right, in our sole
          discretion and without notice to you, to revise the products and
          services available on the Site and to change, suspend or discontinue
          any aspect of the Site and we will not be liable to you or to any
          third party for doing so. We may also impose rules for and limits on
          the use of the Site or restrict your access to part, or all, of the
          Site without notice or penalty. Your continued use of the Site will
          constitute your acceptance of any such changes.
        </p>
        <p>
          You are responsible for your own communications, including the
          transmission, uploading or posting of information to the Site and are
          responsible for the consequences of such communications. Any other use
          of the Site requires the prior written consent of Chic Beauty Inc. You
          may not otherwise copy, modify, or distribute the contents of this
          Site without the prior written consent of Chic Beauty Inc. You may not
          modify, publish, transmit, participate in the transfer of, sell,
          create derivative works from, or in any way exploit any of the content
          found on the Site, in whole or in part. We require all Members to
          agree not to use the Site, and specifically prohibit any use of the
          Site, for any of the following purposes:
        </p>
        <ul>
          <li>
            Posting, communicating or transmitting any material that infringes
            on any intellectual property, publicity or privacy rights of another
            person or entity;
          </li>
          <li>
            Posting any information which is untrue, inaccurate or not your own;
          </li>
          <li>
            Engaging in conduct that would constitute a criminal offense or give
            rise to civil liability or otherwise violate any law or regulation;
          </li>
          <li>
            Attempting to interfere in any way with the Site, or Chic Beauty
            Box’s network security, or attempting to use the Site's service to
            gain unauthorized access to any other computer system; and
          </li>
          <li>Using the Site to drop ship merchandise to third parties.</li>
        </ul>
        <p>
          You may not use robots and other data mining techniques to catalog,
          download or otherwise reproduce, store or distribute content available
          on the Site. Further, unless authorized in writing or through explicit
          release to the general public, you may not access any function or
          feature of the Site through our API (Application Programing
          Interface). You may not take any action to interfere with, or disrupt,
          the Site or any other user's use of the Site, including, without
          limitation, via means of DDOS attacks, circumventing security or user
          authentication measures or attempting to exceed the limited
          authorization and access granted to you under these Terms. You may not
          resell use of, or access to, the Site to any third party without the
          prior written consent of Chic Beauty Inc.
        </p>
        <h4 id="toc2">2. Registration and Passwords</h4>
        <p>
          In order to access certain services on the Site, you will be required
          to provide specific information. All information about you must be
          truthful, and you may not use any aliases or other means to mask your
          true identity. Any access codes or passwords provided should be
          safeguarded at all times. You are responsible for the security of your
          access codes and passwords and will be solely liable for any use or
          unauthorized use of the Site under such access codes or passwords. You
          agree to notify us immediately of any unauthorized access to or use of
          your user name or password or any other breach of security. You should
          use particular caution when accessing your account from a public or
          shared computer so that others are not able to view or record your
          password or other personal information. We may suspend or terminate
          your access at any time with or without notice. To understand how we
          use the information collected from you, please read our{" "}
          <u>
            <Link href="/privacy">
              <a>Privacy Policy</a>
            </Link>
          </u>
          .
        </p>
        <p>
          We have the right to disable any user name, password, or other
          identifier, whether chosen by you or provided by us, at any time in
          our sole discretion for any or no reason, including if, in our
          opinion, you have violated any provision of these Terms.
        </p>
        <h4 id="toc3">3. Additional Terms and Conditions</h4>
        <p>
          You agree that additional terms and conditions may apply to specific
          products, orders or your use of certain portions of the Site,
          including with respect to ordering,{" "}
          <u>
            <Link href="/terms/shipping">
              <a>shipping, cancellation and return policies</a>
            </Link>
          </u>
          ,{" "}
          <u>
            <Link href="/terms/review-guidelines">
              <a>review guidelines</a>
            </Link>
            ,
          </u>{" "}
          <u>
            <Link href="/terms/ugc-terms">
              <a>User Generated Content Terms</a>
            </Link>
          </u>
          ; community guidelines and membership reward programs (including the{" "}
          <u>
            <a href="/terms/loyalty">Loyalty Program Terms</a>
          </u>
          ) and other terms and conditions and policies which you may find
          throughout our Site in connection with certain functionality, features
          or promotions as well as customer service (“Additional Terms”), which
          Additional Terms are made part of these Terms by reference. If there
          is a conflict between these Terms and the Additional Terms, the
          Additional Terms shall control.
        </p>
        <h4 id="toc4">4. Site Not for Minors</h4>
        <p>
          The Site is available to registered and unregistered users who are 18
          years old and older and who have not been suspended or removed by Chic
          Beauty Box for any reason (each, a “Member”). You must be 18 years old
          in order to make a purchase on our Site. If you are under 18 years
          old, then you may not make a purchase on our Site. We reserve the
          right to revoke your ability to access the products and services
          offered on the Site for any reason at any time including as a result
          of a violation of these Terms or the Privacy Policy, without notice.
        </p>
        <h4 id="toc5">5. Fraud Protection</h4>
        <p>
          As part of our order processing procedures, we may screen received
          orders for fraud or other types of unauthorized or illegal activity.
          We reserve the right to refuse to process an order due to suspected
          fraud or unauthorized or illegal activity. If we suspect fraudulent,
          unauthorized or illegal activity, we may reject your order or we may
          contact you at the phone number or email address you provided to
          confirm your order. We also reserve the right to cancel any accounts
          or refuse to ship to certain addresses due to suspected fraud or
          unauthorized or illegal activity. We take these measures to protect
          our customers as well as ourselves from fraud or other unauthorized or
          illegal activity.
        </p>
        <h4 id="toc6">6. Transactions</h4>
        <p>
          If you wish to purchase any product or service made available through
          the Site (each such purchase, a "Transaction"), you may be asked to
          supply certain information relevant to your Transaction including,
          without limitation, your credit card number, the expiration date of
          your credit card, your billing address, and your shipping information.
          You represent and warrant that you have the legal right to use any
          credit card(s) or other payment method(s) utilized in connection with
          any transaction. By submitting such information, you grant to Chic
          Beauty Box the right to provide such information to third parties for
          purposes of facilitating the completion of Transactions initiated by
          you or on your behalf. Verification of information may be required
          prior to the acknowledgment or completion of any Transaction.
        </p>
        <p>
          All descriptions, images, references, features, content,
          specifications, products, and prices of products and services
          described or depicted on the Site are subject to change at any time
          without notice. Certain weights, measures, and other descriptions are
          approximate and are provided for convenience purposes only. The
          inclusion of any products or services on the Site does not imply or
          warrant that these products or services will be available. It is your
          responsibility to ascertain and obey all applicable local, state,
          federal, and international laws (including minimum age requirements)
          in regard to the receipt, possession, use, and sale of any item
          purchased from this Site. By placing an order, you represent that the
          products ordered will be used only in a lawful manner. Chic Beauty Box
          reserves the right, with or without prior notice, to do any one or
          more of the following: (i) limit the available quantity of or
          discontinue any product or service; (ii) impose conditions on the
          honoring of any coupon, coupon code, promotional code, or other
          similar promotion; (iii) bar any user from making or completing any or
          all Transaction(s); and (iv) refuse to provide any user with any
          product or service.
        </p>
        <p>
          You agree that by placing an order on the Site, you are entering into
          a binding contract with Chic Beauty Box and agree to pay all charges
          that may be incurred by you or on your behalf through the Site, at the
          price(s) in effect when such charges are incurred including, without
          limitation, all shipping and handling charges. In addition, you remain
          responsible for any taxes that may be applicable to your Transactions.
        </p>
        <h4 id="toc7">7. The Subscription Contract Between You And Us</h4>
        <p>
          Chic Beauty Box may offer various subscription types: including
          rebillable bi-monthly subscriptions (“Bi-monthly Rebillable
          Subscriptions”); prepaid six or twelve month subscriptions (“Prepaid
          Subscriptions”); rebillable bi-monthly subscriptions with a commitment
          of six months (“6-Month Subscription”) or twelve months (“12-Month
          Subscription”) (collectively “Monthly Subscriptions With Commitment”).
        </p>
        <h4>AUTOMATIC RENEWAL TERMS</h4>
        <p>
          <strong>
            With respect of Chic Beauty Box subscriptions subject to automatic
            renewal, you agree that once you have expressly agreed for your
            credit card to be charged on a recurring basis, and agreed to the
            amount of the recurring charges, Chic Beauty Box may submit periodic
            charges (e.g., monthly) to your chosen payment method without
            further authorization from you, until you provide prior notice at
            any time that you wish to terminate this authorization or to change
            your payment method. You agree that such notice will not affect
            charges submitted before Chic Beauty Box reasonably could act.
            Information on how to cancel is described below.
          </strong>
        </p>
        <h4>BI-MONTHLY REBILLABLE SUBSCRIPTIONS</h4>
        <p>
          By purchasing a Bi-monthly Rebillable Subscription, you agree and
          acknowledge that your subscription has an{" "}
          <strong>
            initial and recurring payment charge at the then-current
            subscription rate plus shipping fees and any applicable taxes, and
            you accept responsibility for all recurring charges prior to
            cancellation
          </strong>
          , including where applicable any charges processed by Chic Beauty Box
          after the expiration date of your payment card.
        </p>
        <p>
          <strong>
            <u>Automatic Bi-Monthly Renewal Terms</u>
          </strong>
        </p>
        <p>
          Your subscription will be{" "}
          <strong>automatically renewed every 2 months</strong> and your payment
          method{" "}
          <strong>
            will automatically be charged every 2 months at the then-current
            subscription rate until you cancel.
          </strong>
        </p>
        <p>
          <strong>
            <u>
              Cancellation Policy For Bi-monthly Rebillable Subscription
              Renewals
            </u>
          </strong>
        </p>
        <p>
          To cancel your Bi-monthly Rebillable Subscription{" "}
          <strong>
            at any time, follow the instructions outlined in{" "}
            <u>
              <a
                href="https://help.chicbeautybox.com/portal/en/kb/articles/how-do-i-cancel-my-subscription"
                target="_blank"
              >
                this article
              </a>
            </u>
            .
          </strong>{" "}
          If you cancel, you will not be rebilled during your next bi-monthly
          billing cycle.
        </p>
        <h4>PREPAID SUBSCRIPTIONS</h4>
        <p>
          By purchasing a Prepaid Subscription, you agree and acknowledge that
          your subscription has an{" "}
          <strong>
            initial pre-payment feature for the applicable length of service
            (six or twelve months) and a recurring Prepaid Subscription renewal
            fee at the then-current applicable Prepaid Subscription rate plus
            shipping fees and any applicable taxes, and you accept
            responsibility for all recurring charges prior to cancellation
          </strong>
          , including, where applicable, any charges processed by Chic Beauty
          Box after the expiration date of your payment card.
        </p>
        <p>
          <strong>
            <u>Automatic Renewal Terms</u>
          </strong>
        </p>
        <p>
          At the end of each Prepaid Subscription term, your subscription will
          be{" "}
          <strong>
            automatically extended for another term of the applicable length of
            service (six or twelve months) and your payment method will
            automatically be charged the applicable Prepaid Subscription renewal
            fee at the then-current Prepaid Subscription rate plus shipping fees
            and any applicable taxes until you cancel
          </strong>{" "}
          your Prepaid Subscription renewal.
        </p>
        <p>
          <strong>
            <u>Cancellation Policy For Prepaid Subscriptions Renewals</u>
          </strong>
        </p>
        <p>
          To cancel the renewal of your Prepaid Subscription, at{" "}
          <strong>
            at any time, follow the instructions outlined in{" "}
            <u>
              <a href="https://help.chicbeautybox.com/portal/en/kb/articles/how-do-i-cancel-my-subscription">
                this article
              </a>
            </u>
            .
          </strong>{" "}
          If you cancel the auto-renewal, your subscription privileges will
          remain active until the end of your then-current subscription term.
        </p>
        <h4>CHANGES TO THE PRICE AND TO CHIC BEAUTY BOX SUBSCRIPTIONS PLANS</h4>
        <p>
          We reserve the right to adjust pricing for our service or any
          components thereof in any manner and at any time as we may determine
          in our sole and absolute discretion. Except as otherwise expressly
          provided for in these Terms, any price changes or changes to your Chic
          Beauty Box Subscriptions Plans will take effect following notice to
          you.
        </p>
        <h4 id="toc8">8. Product Information; Limitation on Quantities</h4>
        <p>
          Excluding any content that may be submitted by Members from time to
          time, we strive to ensure that the information on the Site is complete
          and reliable. Certain information may contain pricing errors,
          typographical errors and other errors or inaccuracies, which we may
          correct without liability. We also reserve the right to limit
          quantities purchased by Members and to revise, suspend, or terminate
          an event or promotion at any time without notice (including after an
          order has been submitted or acknowledged). We do not guarantee that
          all products described on our Site will be available.
        </p>
        <h4 id="toc9">9. Proprietary Rights</h4>
        <p>
          You acknowledge and agree that the content (other than content that
          may be submitted by Members), materials, text, images, videos,
          graphics, trademarks, logos, icons, music, software and other elements
          available on the Site are the property of Chic Beauty Box or our
          licensors and are protected by Canadian and international copyright,
          trademark and/or other intellectual property or proprietary rights and
          laws. These Terms permit you to use the Site for your personal,
          non-commercial use only. You agree not to sell, license, rent,
          distribute, copy, reproduce, transmit, publicly display, publicly
          perform, publish, adapt, edit, modify or create derivative works from
          any content or materials on the Site.
        </p>
        <p>
          If you print, copy, modify, download, or otherwise use or provide any
          other person with access to any part of the Site in breach of the
          Terms, your right to use the Site will stop immediately and you must,
          at our option, return or destroy any copies of the materials you have
          made.{" "}
        </p>
        <p>
          Chic Beauty Box and the Chic Beauty Box logo are trademarks of Chic
          Beauty Inc. All other trademarks names, product, services names,
          designs, and slogan are the property of their respective owners. All
          of our Site's content is copyrighted by Chic Beauty Inc. All rights
          reserved.{" "}
          <strong>
            Except as expressly set forth in these Terms, no license is granted
            to you and no rights are conveyed by virtue of accessing or using
            the Site. All rights not granted under these Terms are reserved by
            Chic Beauty Box.
          </strong>
        </p>
        <p>
          If you submit an unsolicited idea to us via the Site or through any
          other means, you understand and acknowledge that such idea is not
          submitted in confidence and we assume no obligation, expressed or
          implied, by considering it. You further understand that we shall
          exclusively own all known or hereafter existing rights to the idea
          everywhere in the world, and that such idea is hereby irrevocably
          assigned to us. Without limiting the foregoing, to the extent any such
          assignment is deemed unenforceable, and or to the extent necessary for
          Chic Beauty Box to utilize your idea, you hereby grant Chic Beauty Box
          an irrevocable, perpetual, world-wide license to use the idea and any
          associated intellectual property in any manner, in any medium now
          known or hereafter developed, without compensation to you.
        </p>
        <p>
          If the Site contains links to other sites and resources provided by
          third parties, these links are provided for your convenience only.
          This includes links contained in advertisements, including banner
          advertisements and sponsored links. We have no control over the
          contents of those sites or resources, and accept no responsibility for
          them or for any loss or damage that may arise from your use of them.
          If you decide to access any of the third-party websites linked to this
          Site, you do so entirely at your own risk and subject to the terms and
          conditions of use for such websites.
        </p>
        <h4 id="toc10">10. Contributed Content Guidelines</h4>
        <p>
          Chic Beauty Box values your engagement. When contributing content,
          please remember the following guidelines:
        </p>
        <ul>
          <li>
            By submitting or posting any materials or content on the Site, you
            grant Chic Beauty Box a perpetual, irrevocable, non-terminable,
            worldwide, royalty-free and non-exclusive license to use, copy,
            distribute, publicly display, modify, create derivative works, and
            sublicense such materials or any part of such materials. You hereby
            represent, warrant and covenant that any materials you provide do
            not include anything (including, but not limited to, text, images,
            music or video) to which you do not have the full right to grant
            Chic Beauty Box the license specified above. You further represent,
            warrant and covenant that any materials you provide will not contain
            libelous or otherwise unlawful, abusive or obscene material. Chic
            Beauty Box will be entitled to use any content submitted by you
            without incurring obligations of confidentiality, attribution or
            compensation to you.
          </li>
          <li>
            All contributed content is subject to the Terms, which include our
            policy regarding copyright infringement, and our{" "}
            <u>
              <Link href="/terms/ugc-terms">
                <a>User Generated Content Terms</a>
              </Link>
            </u>
            ;
          </li>
        </ul>
        <p>
          We reserve the right not to post your content if it contains any of
          the following types of content or violates other guidelines. By way of
          example, and not as a limitation, you agree that when contributing
          content, you will not:
        </p>
        <ul>
          <li>
            Defame, abuse, harass, stalk, threaten or otherwise violate the
            legal rights (such as rights of privacy and publicity) of others;
          </li>
          <li>
            Use obscenities, discriminatory language, or other language not
            suitable for a public forum;
          </li>
          <li>
            Post advertisements, “spam” content, or references to other
            products, offers, or websites;
          </li>
          <li>
            Post email addresses, URLs, phone numbers, physical addresses or
            other forms of contact information;
          </li>
          <li>
            Post unduly critical or spiteful comments of other content posted on
            the page or its authors;
          </li>
          <li>
            Post files that contain software or other material protected by
            intellectual property laws (or by rights of privacy or publicity)
            unless you own or control the rights thereto or have expressly
            received all necessary consents;
          </li>
          <li>
            Post files or content that contain viruses, corrupted files, or any
            other similar software or programs that may damage the operation of
            another's computer;
          </li>
          <li>
            Falsify or delete any author attributions, legal or other proper
            notices or proprietary designations or labels of the origin or
            source of software or other material contained in a file that is
            uploaded, or impersonate any person or entity or falsely state or
            misrepresent your affiliation with any person or entity;
          </li>
        </ul>
        <p>
          We are under no obligation to screen or monitor any content, but may
          review the content from time to time at our sole discretion. We
          reserve the right to edit or remove any content at our sole discretion
          for any reason.
        </p>
        <p>
          Under no circumstances will Chic Beauty Box be liable in any way for
          any content or materials of any third parties, including, but not
          limited to, for any errors or omissions in any content, or for any
          loss or damage of any kind incurred as a result of the use of any such
          content. We do not endorse, support, represent or guarantee the
          completeness, truthfulness, accuracy, or reliability of any such
          content or communications posted on the Site or endorse any opinions
          expressed therein.{" "}
        </p>
        <p>
          In addition, if you wish to share feedback with us about product
          selection, pricing, ordering, delivery or other customer service
          issues, please do not submit this feedback through a content
          submission. Instead, contact us directly via support@chicbeautybox.com
          or through our{" "}
          <u>
            <a href="https://help.chicbeautybox.com">help center</a>
          </u>
          .
        </p>
        <h4 id="toc11">11. General Disclaimers</h4>
        <p>
          You assume all responsibility and risk with respect to your use of the
          Site. THE SITE AND ALL CONTENT, MERCHANDISE, AND OTHER INFORMATION ON
          OR ACCESSIBLE FROM OR THROUGH THIS SITE OR A “LINKED” SITE ARE
          PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS WITHOUT WARRANTY OF
          ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
          IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
          PURPOSE, NON-INFRINGEMENT, SECURITY OR ACCURACY. SPECIFICALLY, BUT
          WITHOUT LIMITATION, CHIC BEAUTY BOX DOES NOT WARRANT THAT: (1) THE
          INFORMATION ON THIS SITE IS CORRECT, ACCURATE OR RELIABLE; (2) THE
          FUNCTIONS CONTAINED ON THIS SITE WILL BE UNINTERRUPTED OR ERROR-FREE;
          OR (3) DEFECTS WILL BE CORRECTED, OR THAT THIS SITE OR THE SERVERS
          THAT MAKE IT AVAILABLE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.{" "}
        </p>
        <p>
          Chic Beauty Box makes no warranties of any kind regarding any site not
          owned and/or operated by Chic Beauty Box to which you may be directed
          or hyperlinked from this Site. Hyperlinks are included solely for your
          convenience, and Chic Beauty Box makes no representations or
          warranties with regard to the accuracy, availability, suitability or
          safety of information provided in such sites. Chic Beauty Box does not
          endorse, warrant or guarantee any products or services offered or
          provided by or on behalf of third parties on the Site.
        </p>
        <p>
          CHIC BEAUTY BOX DOES NOT REPRESENT OR WARRANT THAT THE NUTRITION,
          INGREDIENT, ALLERGEN, AND OTHER PRODUCT INFORMATION ON OUR SITE IS
          ACCURATE OR COMPLETE SINCE THIS INFORMATION IS PROVIDED BY THE PRODUCT
          MANUFACTURERS OR SUPPLIERS AND ON OCCASION MANUFACTURERS MAY MODIFY
          THEIR PRODUCTS AND UPDATE THEIR LABELS. WE RECOMMEND THAT YOU DO NOT
          RELY SOLELY ON THE INFORMATION PRESENTED ON OUR SITE AND THAT YOU
          CONSULT THE PRODUCTS LABEL OR CONTACT THE MANUFACTURER DIRECTLY IF YOU
          HAVE A SPECIFIC DIETARY OR ALLERGIC CONCERN OR QUESTION ABOUT A
          PRODUCT.
        </p>
        <h4 id="toc12">12. Disclaimer – No Professional Advice</h4>
        <p>
          Any information provided by us regarding the products or otherwise
          (e.g. product descriptions or instructions) is for informational
          purposes only. You should not take any action based upon any
          information contained on the Site. Use of the Site is not meant to
          serve as a substitute for professional advice. You should read and
          strictly follow all product labels, packaging inserts and instructions
          and all manufacturer directions and warnings and seek independent
          professional advice when appropriate.
        </p>
        <p>
          This Site may include content provided by third parties, including
          materials provided by other users, bloggers, and third-party
          licensors, syndicators, aggregators, and/or reporting services. All
          statements and/or opinions expressed in these materials, and all
          articles and responses to questions and other content, other than the
          content provided by Chic Beauty Box are solely the opinions and the
          responsibility of the person or entity providing those materials.
          These materials do not necessarily reflect the opinion of Chic Beauty
          Box. We are not responsible, or liable to you or any third party, for
          the content or accuracy of any materials provided by any third
          parties.
        </p>
        <h4 id="toc13">13. Taxes</h4>
        <p>
          Your total price will include the price of the product plus shipping
          fees, and any applicable sales tax; such provincial, state or local
          sales tax is based on the shipping address and the sales tax rate in
          effect at the time you purchase the product. We will charge tax only
          for Members residing in Canada.
        </p>
        <h4 id="toc14">14. Indemnification</h4>
        <p>
          You agree to indemnify, hold harmless, and defend Chic Beauty Box, its
          parent, subsidiaries, divisions, and affiliates, and their respective
          officers, directors, employees, agents and affiliates from any and all
          claims, liabilities, damages, costs and expenses of defense, including
          attorneys’ fees, in any way arising from or related to your use of the
          Site, your violation of these Terms, defamatory or infringing content
          posted to the Site by you, or your violation of any law or the rights
          of a third party.
        </p>
        <h4 id="toc15">15. Limitation of Liability</h4>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL CHIC BEAUTY
          BOX, ITS PARENT COMPANY, SUBSIDIARIES, AFFILIATES OR ANY OF THEIR
          RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUCCESSORS,
          SUBSIDIARIES, SUPPLIERS, AFFILIATES, OR THIRD PARTIES PROVIDING
          INFORMATION ON THIS SITE BE LIABLE TO ANY USER OF THE SITE OR ANY
          OTHER PERSON OR ENTITY FOR ANY INDIRECT, SPECIAL, INCIDENTAL,
          CONSEQUENTIAL OR EXEMPLARY DAMAGES (INCLUDING, BUT NOT LIMITED TO,
          DAMAGES FOR LOSS OF PROFITS, LOSS OF DATA, OR LOSS OF USE) ARISING OUT
          OF THE USE OR INABILITY TO USE THE SITE, WHETHER BASED UPON WARRANTY,
          CONTRACT OR TORT (NEGLIGENCE), EVEN IF CHIC BEAUTY BOX HAS BEEN
          ADVISED OF OR SHOULD HAVE KNOWN OF THE POSSIBILITY OF SUCH DAMAGES OR
          LOSSES. TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL THE
          TOTAL AGGREGATE LIABILITY OF CHIC BEAUTY BOX, ITS AFFILIATES OR ANY OF
          THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUCCESSORS,
          SUBSIDIARIES, SUPPLIERS, AFFILIATES OR THIRD PARTIES PROVIDING
          INFORMATION ON THIS SITE TO YOU FOR ANY DIRECT DAMAGES, EXCEED THE
          AMOUNT YOU PAID TO CHIC BEAUTY BOX IN CONNECTION WITH THE EVENT GIVING
          RISE TO SUCH LIABILITY.{" "}
        </p>
        <h4 id="toc16">16. International Use</h4>
        <p>
          We control and operate the Site from Canada. We make no representation
          that materials on the Site are appropriate or available for use
          outside of Canada. If you choose to access this Site from outside
          Canada, you do so at your own initiative and are responsible for
          compliance with local laws, if and to the extent local laws are
          applicable.
        </p>
        <h4 id="toc17">17. Risk of Loss</h4>
        <p>
          Any merchandise purchased from our Site will be shipped by a third
          party carrier. As a result, title and risk of loss for such
          merchandise will pass to you upon our delivery to the carrier.
        </p>
        <h4 id="toc18">
          18. Copyright Infringement; Notice and Take Down Procedures
        </h4>
        <p>
          Chic Beauty Box specifically prohibits the posting of any content that
          violates or infringes the copyright rights and/or other intellectual
          property rights (including rights of privacy and publicity) of any
          person or entity. If you believe that any material contained on this
          Site infringes your copyright or other intellectual property rights,
          you should notify us of your copyright infringement claim in
          accordance with the following procedure. Chic Beauty Box will process
          notices of alleged infringement that it receives and will take
          appropriate action as required by the Copyright Modernization Act of
          Canada (“CMAC”).
        </p>
        <h4 id="toc19">19. Waiver; Remedies</h4>
        <p>
          The failure of Chic Beauty Box to partially or fully exercise any
          rights or the waiver of Chic Beauty Box of any breach of these Terms
          by you shall not prevent a subsequent exercise of such right by Chic
          Beauty Box or be deemed a waiver by Chic Beauty Box of any subsequent
          breach by you of the same or any other term of these Terms. The rights
          and remedies of Chic Beauty Box under these Terms and any other
          applicable agreement between you and Chic Beauty Box shall be
          cumulative, and the exercise of any such right or remedy shall not
          limit Chic Beauty Box’s right to exercise any other right or remedy.
        </p>
        <h4 id="toc20">20. Governing Law</h4>
        <p>
          All matters related to the Site, and these Terms shall be governed and
          construed in accordance with the laws of the Province of Ontario
          without regard to conflict of laws provisions.
        </p>
        <h4 id="toc21">21. Disputes</h4>
        <p>
          Any dispute relating in any way to your visit to, or use of, the Site,
          to the products you purchase through the Site (including a
          subscription), or to your relationship to Chic Beauty Box ("Claims")
          shall be exclusively submitted to confidential and binding arbitration
          in Toronto, Ontario, including based on contract, tort (including
          intentional tort), fraud, agency, your or our negligence, statutory or
          regulatory provisions, or any other sources of law; Claims made as
          counterclaims, cross-claims, third- party claims, interpleaders or
          otherwise; and Claims made independently or with other claims;
          provided, however, that to the extent that you have in any manner
          violated or threatened to violate our intellectual property rights, we
          may seek injunctive or other appropriate relief in any provincial or
          federal court in the Province of Ontario. The party filing arbitration
          must submit Claims to The International Centre for Dispute Resolution
          Canada and follow its rules and procedures for initiating and pursuing
          arbitration. Any arbitration hearing that you attend will be held at a
          place chosen by The International Centre for Dispute Resolution
          Canada.
          <strong>
            YOU SHALL NOT BE ENTITLED TO JOIN OR CONSOLIDATE CLAIMS IN
            ARBITRATION BY OR AGAINST OTHER USERS OR TO ARBITRATE ANY CLAIM AS A
            REPRESENTATIVE OR MEMBER OF A CLASS OR IN A PRIVATE ATTORNEY GENERAL
            CAPACITY
          </strong>
          . You may obtain copies of the current rules, and forms and
          instructions for initiating arbitration by contacting The
          International Centre for Dispute Resolution Canada using the contact
          information noted below.
        </p>
        <p />
        <div className="text-center">
          The International Centre for Dispute Resolution Canada
          <br />
          Website:{" "}
          <u>
            <a href="https://www.icdr.org/icdrcanada" target="_blank">
              www.icdr.org/icdrcanada
            </a>
          </u>
        </div>
        <p />
        <p>
          A single, neutral arbitrator will resolve Claims. The arbitrator will
          be either a lawyer with at least ten (10) years’ experience or a
          retired or former judge, selected in accordance with the rules of the
          The International Centre for Dispute Resolution Canada. The
          arbitration will follow the procedures and rules of The International
          Centre for Dispute Resolution Canada which are in effect on the date
          the arbitration is filed unless those procedures and rules are
          inconsistent with these Terms, in which case these Terms will prevail.
          Those procedures and rules may limit the discovery available to you or
          us. The arbitrator will take reasonable steps to protect your customer
          account information and other confidential information if requested to
          do so by you or us. Each party to the arbitration will bear the
          expense of that party's attorneys, experts, and witnesses, and other
          expenses, regardless of which party prevails, but a party may recover
          any or all expenses from another party if the arbitrator, applying
          applicable law, so determines. The arbitrator's award is final and
          binding on the parties.{" "}
        </p>
        <p>
          <strong>
            ANY CLAIM YOU HAVE MUST BE COMMENCED WITHIN ONE (1) YEAR AFTER THE
            DATE THE CLAIM ARISES. AS NOTED ABOVE, YOU AND CHIC BEAUTY BOX
            HEREBY VOLUNTARILY AND KNOWINGLY WAIVE ANY RIGHT EITHER MAY HAVE TO
            A JURY TRIAL.
          </strong>
        </p>
        <p>
          We will not choose to arbitrate any Claim you bring in small claims
          court. However, if such a Claim is determined by the court to be
          outside its jurisdiction, the parties agree that the dispute shall
          then be submitted to arbitration.
        </p>
        <h4 id="toc22">22. Changes of the Site</h4>
        <p>
          We may update the content on the Site from time to time. In addition,
          Chic Beauty Box reserves the right to revise these Terms at any time
          by updating this posting; provided any material modifications will
          only be applied prospectively. Any changes to the Terms will be in
          effect as of the “Last Updated Date” referenced on the Site. You are
          encouraged to review these Terms each time you use the Site and prior
          to purchasing any product or service that are available through this
          Site. Your continued use of the Site after the posting of changes will
          constitute your acceptance of and agreement with such changes.
        </p>
        <h4 id="toc23">23. Your Feedback</h4>
        <p>
          This Site is operated by Chic Beauty Inc. All feedback, comments,
          requests for technical support, and other communications relating to
          the Site should be done through our{" "}
          <u>
            <a href="https://help.chicbeautybox.com" target="_blank">
              help center
            </a>
          </u>
          .
        </p>
      </div>
    </TermsContainer>
  );
}
